module.exports = __webpack_public_path__ + "static/media/menu_01.fe1c5811.jpg";